import { colorSet } from '@components/Provider';
import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  popoverRoot: {
    top: '61px !important',
    right: '32px !important',
    left: 'initial !important',
    transform: 'initial !important',
    zIndex: 5000,
    [theme.breakpoints.down('xs')]: {
      top: '49px !important',
      right: '16px !important'
    }
  },
  root: {
    width: '100%',
    background: '#fff',
    flexWrap: 'nowrap',
    height: 600,
    minWidth: 358,
    maxWidth: 358,
    backgroundColor: colorSet.gray000,
    borderRadius: 8,
    flexDirection: 'column',
    boxShadow:
      '0px 4px 5px -2px rgba(0, 0, 0, 0.2), 0px 7px 10px 1px rgba(0, 0, 0, 0.14), 0px 2px 16px 1px rgba(0, 0, 0, 0.12)',
    transition: 'height 0.7s ease-in-out',
    borderRight: '0px 0px 8px 8px',
    [theme.breakpoints.down('xs')]: {
      minWidth: 343,
      maxWidth: 343
    }
  },
  header: {
    padding: '16px 20px',
    borderBottom: `1px solid ${colorSet.gray200}`,
    '& > :first-child': {
      marginBottom: 16
    }
  },
  checkedCircle: {
    marginRight: 6
  },
  content: {
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    overflow: 'scroll',
    borderRadius: '0px 0px 8px 8px'
  },
  iconButton: {
    padding: 6,
    '&:hover': {
      backgroundColor: colorSet.gray100
    },
    '& .MuiBadge-badge': {
      fontSize: 9,
      whiteSpace: 'nowrap'
    },
    [theme.breakpoints.down('xs')]: {
      padding: 0,
      marginLeft: 8,
      '& .MuiBadge-dot': {
        height: 6,
        minWidth: 6,
        top: 2,
        right: 2
      }
    }
  },
  bellSvg: {
    color: colorSet.gray900
  },
  btnGroup: {
    '& > :first-child': {
      marginRight: 0
    }
  },
  backDrop: {
    zIndex: 4999
  },
  cardCTA: {
    display: 'flex',
    marginTop: 16,
    alignItems: 'center',
    '& svg': {
      marginLeft: 2
    }
  }
}));
